import { FilterBodyListConfig } from '@/components/FilterNew/components/Body/types';
import {
  UseFilterValuesType,
  UseOptionsQueryParams,
  UseOptionsQueryReturnType,
} from '@/components/FilterNew/types';
import StaffRoleIcon from '@/modules/corporate/modules/staff-roles/components/StaffRoleIcon';
import { StaffRoleFragment } from '@/modules/corporate/modules/staff-roles/graphql/fragments/generated/StaffRole';
import { useStaffRolesQuery } from '@/modules/corporate/modules/staff-roles/graphql/queries/generated/staffRoles';

import useFilterOptionsQuery from '../../hooks/useFilterOptionsQuery';
import useFilterValue from '../../hooks/useFilterValue';

const getStaffRoleFilterOption = (staffRole: StaffRoleFragment) => ({
  value: staffRole.id,
  label: staffRole.name,
  Icon: () => <StaffRoleIcon tagColor={staffRole.metadata?.tagColor} />,
});

const EDGE_KEY = 'staffRoles';

const useFilterValues: UseFilterValuesType = ({ value }) =>
  useFilterValue({
    value,
    useQuery: useStaffRolesQuery,
    edgeKey: EDGE_KEY,
    variables: {
      filters: {
        roleIds: value,
      },
    },
    getFilterOption: getStaffRoleFilterOption,
  });

const useOptionsQuery = ({ searchText }: UseOptionsQueryParams): UseOptionsQueryReturnType =>
  useFilterOptionsQuery({
    useQuery: useStaffRolesQuery,
    edgeKey: EDGE_KEY,
    variables: { filters: { searchText } },
    getFilterOption: getStaffRoleFilterOption,
  });

export const StaffRoleEntityConfig: FilterBodyListConfig = {
  listVariant: 'multi-ungrouped-infinite',
  useFilterValues,
  useOptionsQuery,
};
